import { useTranslate } from '@tolgee/react';
import { SearchScope } from '@amf/shared/components/search/hooks/useAdvancedSearch';
import { SearchResultWithLeagueFragment } from '@amf/shared/types/graphql';

type Props = {
  item: SearchResultWithLeagueFragment;
  prefixes: { league: string };
};

function LeagueResult({ item }: Props) {
  const { t } = useTranslate();
  return (
    <a className='AdvancedSearch__resultItem'>
      <div className='AdvancedSearch__resultItemImage'>
        <i className='bi bi-trophy-fill' />
      </div>
      <div className='AdvancedSearch__resultItemContent'>
        <div className='AdvancedSearch__resultItemType'>
          {t(`search.scope.${SearchScope.LEAGUES}.one`)}
        </div>
        <h3 className='AdvancedSearch__resultItemTitle'>{item.name}</h3>
        <p className='AdvancedSearch__resultItemDescription'>{item.seasonName}</p>
      </div>
    </a>
  );
}

export default LeagueResult;
